import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { SharedService } from './shareModule/services/shared.service';
import {
  MatBottomSheet,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { ModalService } from './shareModule/services/modal.service';
import { CommonService } from './shareModule/services/common.service';
import { filter, Subject, takeUntil } from 'rxjs';
import { EventType, NavigationEnd, NavigationSkipped, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ScrollStrategy } from '@angular/cdk/overlay';

export type PopupParams = {
  bottomSheetPanelClass: string;
  hasBackdrop: boolean;
  bottomSheetScrollStrategy: ScrollStrategy;

  forceMode?: 'modal' | 'bs' | undefined;
  url?: string | undefined;
  noHistory: boolean

  modalWindowClass: string;
  modalModalClass: string;
  modalSize: 'sm' | 'lg' | 'md' | 'xl';
  modalIsCenter: boolean;
  modalArialLabelBy: string
  modalKeyboard: boolean,
  data: any
};

@Injectable({
  providedIn: 'root',
})
export class PopUpService implements OnInit, OnDestroy {
  constructor(
    private sharedService: SharedService,
    private bottomSheet: MatBottomSheet,
    private modalService: NgbModal,
    private commonService: CommonService,
    private router: Router,
  ) {
    if (this.sharedService.isBrowser()) {
      window.addEventListener('popstate', () => {
        //this._resetScroll()
        console.log('popped');
        if (this._skipWindowPop) {
          console.log('skipping window part')
          this._skipWindowPop = false;
          return
        }

        const topRef = this._modalRefStack.pop()

        topRef.dismiss()
      });
    }

    if (this.sharedService.isBrowser()) {
      this._currentLocation = this.urlWithoutParams
      this.router.events
        .pipe(
          takeUntil(this._destroyed),
          filter((event) => event instanceof NavigationEnd || event instanceof NavigationSkipped),

        )
        .subscribe((e: NavigationEnd) => {
          //console.log('router event', e)

          if (this.urlWithoutParams != this._currentLocation) { //new page so clear
            console.log('went to a new page so clearing',)
            this._modalRefStack = [];
            this._scrollPositions = []
          }
          else {
            console.log('resetting scroll back to old page')
            if (e.type == EventType.NavigationEnd || e.type == EventType.NavigationSkipped) {
              this._resetScroll()
            }

            //same page as old
          }
        });

    }
  }
  private _destroyed = new Subject();
  private _modalRefStack: (MatBottomSheetRef | NgbModalRef | null)[] = [];
  private _scrollPositions = []
  private _currentLocation = ''

  // public addDummy() {
  //   this._modalRefStack.push(null);
  // }
  private _resetScroll() {
    if (!this._scrollPositions.length) {
      console.error("Scroll positions is empty!")
      return;
    }
    const { x, y } = this._scrollPositions.pop();
    console.log({ x, y })
    setTimeout(() => window.scrollTo(x, y))

  }

  public get urlWithoutParams() {
    return window.location.origin + window.location.pathname;
  }
  public clearHistory() {
    this._modalRefStack = [];
    this._scrollPositions = []
  }
  private _skipWindowPop = false
  public openPopup(c: any, params: Partial<PopupParams> = { url: null }): NgbModalRef | MatBottomSheetRef {
    if (!this.sharedService.isBrowser()) {
      console.warn('not a browser could not open a popup');
      return;
    }
    if (!params.noHistory) {
      history.pushState({
        // scrollPosition: {x: window.scrollX || window.pageXOffset, y: window.scrollY || window.pageYOffset}
      }, '', params.url);

    }

    // history.pushState({
    //   // scrollPosition: {x: window.scrollX || window.pageXOffset, y: window.scrollY || window.pageYOffset}
    //  }, '', params.url);
    // this._skipWindowPop

    let ref: NgbModalRef | MatBottomSheetRef;
    const closedCallback = (_) => {
      if (this._currentLocation != this.urlWithoutParams || params.noHistory) {
        return; //closed because of links
      }
      //if back is not pressed but modal is closed then we need to remove the state
      if (this._modalRefStack.length && this._modalRefStack[this._modalRefStack.length - 1] == ref) {
        console.log('closed modal without back being pressed')
        this._skipWindowPop = true;

        if (!(ref as any)?.afterDismissed) { //bottom sheets have their own back so only for modals
          history.go(-1);
        }

        this._modalRefStack.pop()
        // this._resetScroll()
      }
    }


    if ((this.sharedService.isOnMobile && params.forceMode != 'modal') || params.forceMode == 'bs') {


      this._currentLocation = this.urlWithoutParams


      ref = this.bottomSheet.open(c, {
        panelClass: params.bottomSheetPanelClass,
        hasBackdrop: params.hasBackdrop,
        data: params.data,
        closeOnNavigation: true
      });
      ref.afterDismissed().pipe(takeUntil(this._destroyed))
        .subscribe(closedCallback)
    } else {
      ref = this.modalService.open(c, {
        windowClass: params.modalWindowClass,
        size: params.modalSize,
        centered: params.modalIsCenter,
        modalDialogClass: params.modalModalClass,
        ariaLabelledBy: params.modalArialLabelBy,
        keyboard: params.modalKeyboard,
      });
      ref.hidden.pipe(takeUntil(this._destroyed))
        .subscribe(closedCallback)
    }
    this._modalRefStack.push(ref);
    this._scrollPositions.push({ x: window.scrollX || window.pageXOffset, y: window.scrollY || window.pageYOffset })
    return ref;
  }

  ngOnDestroy(): void {
    this._destroyed.complete();
  }

  ngOnInit(): void {


  }
}
